<template>
  <b-container fluid>
    <b-row class="nav-space"></b-row>
    <!-- <b-row class="download" v-if="this.$route.query.sku == 'EFAS_Admiral_Pack' || this.$route.query.sku == 'EFAS_President_Pack'">
      <b-link class="mx-auto my-3" target="_blank" href="https://drive.google.com/file/d/1l7u4nwJ6to2b288HdW16IG9py0lWm5UK/view">Click Here to Download your EFAS Launcher</b-link>
    </b-row> -->
    <b-row>
      <iframe id="blog" src="https://www.efas.io/purchase-completed" frameborder="0" class="blog" height="1200px"></iframe>
    </b-row>
  </b-container>
</template>

<style lang="scss" scoped>
.nav-space{
  height: 40px;
  background: black;
}
.blog{
  width: 100%;
  // height: 2699px;
}
.download{
  background: #2a2a2a;
  font-size: 2em;
}
@include media-breakpoint-up(lg) {
  .nav-space{
    height: 60px;
  }
  .blog{
    width: 100%;
  }
}
</style>

<script>
export default {
  mounted() {
    // 设置页面标题
    document.title = 'Earth From Another Sun Galaxy';

    // sku
    let skuMap = new Map();
    skuMap.set("EFAS_Founder_Pre_Order",29.95);
    skuMap.set("EFAS_Admiral_Pack",49.95);
    skuMap.set("EFAS_President_Pack",149.95);
    skuMap.set("EFAS_Lovebirds_Pack",49.95);
    skuMap.set("EFAS_Paramour_Pack",149.95);
    skuMap.set("EFAS_DRMFREE",29.95);

    // facebook pixel 初始化
    !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '551410272180280');
    // fbq('init', '937634820381043');
    // fbq('track', 'PageView');

    // google conversion 初始化
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://www.googletagmanager.com/gtag/js?id=AW-430830816'
    document.getElementsByTagName('head')[0].appendChild(script)
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-430830816');
    // 根据sku触发
    if(skuMap.has(this.$route.query.sku)){
      fbq('track', 'Purchase', {
        currency: "USD",
        value: skuMap.get(this.$route.query.sku),
        transaction_id: this.$route.query.invoice_id
      });
      gtag('event', 'conversion', {
        'send_to': 'AW-430830816/xP6mCP_lhvYBEODpt80B',
        'value': skuMap.get(this.$route.query.sku),
        'currency': 'USD',
        'transaction_id': this.$route.query.invoice_id
      });
    }
    else{
      // fbq('track', 'Purchase', {currency: "USD"});
    }
  }
}
</script>
